import { getEntityContext, contextToStorePath } from 'app/infrastructure/ui/renderer/resolvers';
import get from 'lodash/get';
import { api } from '../loss-potential-evaluation/api';
import { getUserMessage } from 'app/infrastructure/notifications/user-messages/get-user-message';
import { AddRiskEvaluationInitialValues } from 'app/area/case/features/loss-potential-evaluation/types';
import { actionCreators as draftActionCreators } from 'app/area/case/draft/actions';
import { ReceiveCopyRiskEvaluation, RequestCopyRiskEvaluation } from 'app/area/case/features/loss-potential-evaluation/action-types';
import { whenIdle } from 'app/infrastructure/redux/when-idle';
import * as navigate from 'app/area/shared/navigation';
import { sectionId, tableName } from 'app/area/case/case-data-model';
import { RiskMatrixInstance } from 'app/area/case/components/loss-potential/constants';
import { actionCreators as responseCachingActionCreators } from 'app/area/shared/response-caching/actions';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import { isCaseViewModalOpen, shouldOpenCaseInModal } from 'app/components/helpers';

function selectFromState(state: any, uiEngineProps: any) {
  const hostProps = uiEngineProps.hostProps();
  const caseState = get(state, uiEngineProps.hostProps().statePath);
  const context = getEntityContext(caseState, uiEngineProps);

  return {
    state,
    hostProps,
    caseState,
    context
  };
}

const toasts = toastFactory();

export const actionCreators = {
  copyRiskEvaluation: (uiEngineProps: any, riskMatrixInstance: number, instanceCopyCmd: number,
    initialValues: AddRiskEvaluationInitialValues, copyToResidual: boolean = false) =>
    async (dispatch: any, getState: any) => {
      const {
        context
      } = selectFromState(getState(), uiEngineProps);
      const state = getState().caseArea;
      const parentPath = contextToStorePath(uiEngineProps.componentDescriptor, context);
      const transNo = parentPath[0]?.tblTrans;
      const utcOffset = getState().app.settings.utcOffset;
      const targetSection = riskMatrixInstance === RiskMatrixInstance.LossPotential ? sectionId[tableName.lossPotentialEvaluation].section :
        sectionId[tableName.lossPotentialResidualEvaluation].section;

      try {
        if (!!state.editing) {
          await dispatch(draftActionCreators.requestImmediateSave());
          await dispatch(new RequestCopyRiskEvaluation());
          await dispatch(
            whenIdle(async (_: any) => {
              return await api.addRiskEvaluationEdit(transNo, riskMatrixInstance, instanceCopyCmd, initialValues, { utcOffset });
            })
          );
          await dispatch(new ReceiveCopyRiskEvaluation());
          await dispatch(draftActionCreators.editDraft(transNo));
          navigate.toSection(targetSection);
          await dispatch(draftActionCreators.selectDocumentItem(uiEngineProps?.childItem));
        }
        else {
          const navigateToRiskEvaluationSection = (draftId: number) => copyToResidual ?
            navigate.toCaseAddRiskEvaluations(draftId, sectionId[tableName.lossPotentialEvaluation].section) :
            navigate.toCaseAddLossPotentialEvaluation(draftId, sectionId[tableName.lossPotentialEvaluation].section);
          
          const navigateToRiskEvaluationSectionInModal = (draftId: number) => copyToResidual ?
            navigate.toCaseAddRiskEvaluationsInModal(draftId, sectionId[tableName.lossPotentialEvaluation].section) :
            navigate.toCaseAddLossPotentialEvaluationInModal(draftId, sectionId[tableName.lossPotentialEvaluation].section);          

          dispatch(new RequestCopyRiskEvaluation());
          const response = await api.addRiskEvaluationRead(transNo, riskMatrixInstance, instanceCopyCmd, initialValues, { utcOffset },
            copyToResidual);
          const pathname = new URL(response.headers.get('Location'))?.pathname?.split('/');
          const draftIdFromResponse = Number(pathname?.[pathname.length - 1]);
          dispatch(new ReceiveCopyRiskEvaluation());
          if (isCaseViewModalOpen()) {
            navigateToRiskEvaluationSectionInModal(draftIdFromResponse);
            return;
          }
          if (shouldOpenCaseInModal(!!uiEngineProps?.selectedReport)) {
            navigateToRiskEvaluationSectionInModal(draftIdFromResponse);
            return;
          }
          navigateToRiskEvaluationSection(draftIdFromResponse);
          return;        
        }

      } catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
      }
    },

  getUiDefinition: (caseTypeId: number, caseContextId: number) =>
    async (dispatch: any, getState: any) => {
      try {
        const uiDefinition = await dispatch(responseCachingActionCreators.getUiDefinition(caseTypeId, caseContextId));
        return uiDefinition?.rootDomain;
      }
      catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
      }
    }
};
